import { Component, EventEmitter, Output } from '@angular/core';
import { WalletService } from '../../Service/wallet/wallet.service';
import { formatDate } from '@angular/common';
import { ReloadService } from '../../Service/Reload-service/reload.service';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-distributor-wallet',
  templateUrl: './distributor-wallet.component.html',
  styleUrl: './distributor-wallet.component.scss'
})
export class DistributorWalletComponent {
  availableBalance: number = 0;
  transactions: any;
  displayAddBalance = false;
  userId: number | null = null;
  accessType: number = 0;
  dateRange: Date[] | null = null;
  searchQuery: string = '';

  pageNumber: number = 1;
  pageSize: number = 10;

  allLoaded: boolean = false;
  isLoading: boolean = false;
  totalRecords: number = 0;
  first: number = 0;
  rowsPerPage: number = 10;
  noDataInRange: boolean = false;
  //totalPages: any;
  
  constructor(
    private walletService: WalletService,
    private reloadService: ReloadService,
    private http: HttpClient, private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    this.accessType = JSON.parse(localStorage.getItem('user') || '{}').accessType;
    this.loadUserId();
    this.loadWalletBalance();
    this.loadTransactionHistory();
  }

  private loadUserId(): void {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    this.userId = user?.userId || null;
    console.log('User ID:', this.userId);
  }

  private loadWalletBalance(): void {
    this.walletService.getWalletBalance().subscribe({
      next: (response) => {
        this.availableBalance = response.availableBalance;
      },
      error: (error) => {
        console.error('Error fetching wallet balance:', error);
      }
    });
  }

  private loadTransactionHistory(): void {
    const body = {};

    const queryParams: any = {
      PageNumber: this.pageNumber ,
      PageSize: this.pageSize,
      SortBy: '',
      SortDir: 'desc',
    };

    if (this.searchQuery?.trim()) {
      queryParams.SearchQuery = this.searchQuery.trim();
    }

    if (this.dateRange?.[0]) {
      queryParams.StartDate = new Date(this.dateRange[0]).toISOString();
    }

    if (this.dateRange?.[1]) {
      queryParams.EndDate = new Date(this.dateRange[1]).toISOString();
    }

    console.log('Query Params:', queryParams);

    this.walletService.getTransactionHistory(body, queryParams).subscribe({
      next: (response: any) => {
        const txns = response.data || [];
        this.totalRecords = response.recordsFiltered || 0;

        this.transactions = txns.map((tx: any) => {
          const isCredit = tx.transactionType === 'Credit';
          // const formattedDate = formatDate(tx.createdOn, 'MMM d, y', 'en-US'); 
          // const formattedTime = formatDate(tx.createdOn, 'h:mm a', 'en-US'); 
          const transaction = {
            note: tx.note,
            transactionType: tx.transactionType,
            bankReference: tx.bankReferanceNumber,
            description: tx.description,
            details: isCredit ? 'Credited' : 'Debited',
            date: formatDate(tx.createdOn, 'MMM d, y, h:mm a', 'en-US'),
            // date: formattedDate,  
            // time: formattedTime,
            amount: `${isCredit ? '+' : '-'}₹${tx.amount}`,
            icon: isCredit ? 'pi pi-arrow-right' : 'pi pi-arrow-left',
            color: isCredit ? 'green' : 'red',
            filePath: tx.invoice?.filePath || null
          };
          return transaction;
        });

        // Optional: Log the whole array too
        console.log('All transformed transactions:', this.transactions);

      },
      error: (err) => {
        console.error('Failed to fetch transaction history:', err);
      }
    });
  }

  get totalPages(): number {
    // return Math.ceil(this.totalRecords / this.pageSize);
    return Math.max(1, Math.ceil(this.totalRecords / this.pageSize));
  }

  nextPage(): void {
    if (this.pageNumber < this.totalPages) {
      this.pageNumber++;
      this.loadTransactionHistory();
    }
  }

  previousPage(): void {
    if (this.pageNumber > 1) {
      this.pageNumber--;
      this.loadTransactionHistory();
    }
  }
  onDateRangeChanged(event: Date[] | null) {
    this.dateRange = event;
    // Reset page
    this.pageNumber = 0;
    this.first = 0;
    // Reset flag if date is cleared
    if (!event || event.length === 0) {
      console.log('Date range cleared. Reloading all transactions...');
    }

    this.loadTransactionHistory();
  }

  openDialog() {
    this.displayAddBalance = true;
    document.body.style.overflow = 'hidden';
  }
  handleBalanceRefresh() {
    this.loadWalletBalance();
    this.loadTransactionHistory();
  }
  onSearch() {
    this.pageNumber = 0;
    this.first = 0;
    this.transactions = [];
    this.loadTransactionHistory();
  }

  onFilterChange() {
    this.loadTransactionHistory();
  }

  onPageChange(event: any) {
    this.pageNumber = (event.first / event.rows) + 1; 
    this.pageSize = event.rows;

    console.log('Page number:', this.pageNumber + 1);
    console.log('Page size:', this.pageSize);
    this.loadTransactionHistory();
  }
  downloadInvoice(filePath: string) {
    if (filePath) {
      window.open(filePath, '_blank');
    }
  }
}